const MultiMemberLLCAgreement = ({
  signature,
  businessName,
  addressLine1,
  addressLine2,
  city,
  state,
  zipCode,
  customerFirstName,
  customerLastName,
  email,
  signFirstName,
  signLastName,
  password,
  ip,
}) => {
  return (
    <div className="row">
      <div className="col-lg-10 mx-auto">
        <h3 className="heading text-center">
          Multi-Member LLC Builder Registration
        </h3>
        <h4 className="heading text-center">Formation Not Included</h4>
        <form className="row form-main">
          <div className="col-lg-12 mb-3 mt-2">
            <label htmlFor="businessName" className="form-label">
              Business Name
            </label>
            <input
              type="text"
              className="form-control"
              id="businessName"
              aria-describedby="emailHelp"
              value={businessName}
            />
          </div>

          <h6 htmlFor="addressLine1" className="form-label">
            Primary Address For the Business
          </h6>

          <div className="col-lg-6 mb-3">
            <label htmlFor="addressLine1" className="form-label">
              Address Line 1
            </label>
            <input
              type="text"
              className="form-control"
              id="addressLine1"
              value={addressLine1}
            />
          </div>

          <div className="col-lg-6 mb-3">
            <label htmlFor="addressLine2" className="form-label">
              Address Line 2
            </label>
            <input
              type="text"
              className="form-control"
              id="addressLine2"
              value={addressLine2}
            />
          </div>
          <div className="col-lg-6 mb-3">
            <label htmlFor="city" className="form-label">
              City
            </label>
            <input
              type="text"
              className="form-control"
              id="city"
              aria-describedby="emailHelp"
              value={city}
            />
          </div>
          <div className="col-lg-6 mb-3">
            <label htmlFor="state" className="form-label">
              State
            </label>
            <input
              type="text"
              className="form-control"
              id="state"
              value={state}
            />
          </div>
          <div className="col-lg-6 mb-3">
            <label htmlFor="zipCode" className="form-label">
              ZIP Code
            </label>
            <input
              type="text"
              className="form-control"
              id="zipCode"
              aria-describedby="emailHelp"
              value={zipCode}
            />
          </div>
          <div className="col-lg-6 mb-3">
            <label htmlFor="email" className="form-label">
              Your Email
            </label>
            <input
              type="text"
              className="form-control"
              id="email1"
              aria-describedby="emailHelp"
              value={email}
            />
          </div>
          <h6>Your Name</h6>
          <div className="col-lg-6 mb-3">
            <label htmlFor="customerFirstName" className="form-label">
              First Name
            </label>
            <input
              type="text"
              className="form-control"
              id="customerFirstName"
              value={customerFirstName}
            />
          </div>
          <div className="col-lg-6 mb-3">
            <label htmlFor="customerLastName" className="form-label">
              Last Name
            </label>
            <input
              type="text"
              className="form-control"
              id="customerLastName"
              value={customerLastName}
            />
          </div>
        </form>
        <div className="mt-4">
          <h6>
            Foundry Law Group is here to help you build your LLC. We hope that
            you will find our LLC Builder and legal counsel both efficient and
            insightful, freeing you to launch your business with confidence that
            the behind-the-scenes legal is handled. Building a business is hard
            work; forming the company shouldn&apos;t be. Welcome to the LLC
            Builder!
          </h6>
          <p>
            To use our LLC Builder, we ask that you agree to the following terms
            of engagement. These terms of engagement are between Foundry Law
            Group PLLC, and the identified business (or yet-to-be-formed)
            entered on the registration form. The LLC Builder is still in beta
            on select features and technical aspects. If you encounter any
            hiccups or questions, please contact us at info@foundrylawgroup.com
            or reach out directly to the managing attorney for your project.
          </p>
          <p>
            <b> Limited Engagement.</b> Upon registration and payment of the
            agreed fees, your named business will be a client of Foundry Law
            Group PLLC. We will be representing the business in connection with
            the LLC Builder and not any of its founders, officers, members,
            managers, agents, or other representatives in their individual
            capacities. Our engagement and the formation of an attorney-client
            relationship will be solely in connection with the LLC Builder and
            those identified deliverables and services. After we complete the
            LLC Builder Scope of Work, the attorney-client relationship will be
            automatically terminated. You may of course reach out to us
            regarding any other legal matters and we would be happy to discuss
            how we may be able to help. If we choose to represent you in
            connection with any other legal matter, we will request a new
            engagement letter at that time.
          </p>
          <p>
            It is important to understand that this limited representation for
            the LLC Builder means that we are not legal counsel regarding any
            other aspects of your business, including, but not limited to, any
            defects or other problems arising from a prior business formation
            process, issuances of ownership interests to persons other than
            founders and business partners (for example, investors), tax
            matters, disputes of any nature, trademarks or trade names,
            copyrights, the business plan and any legal compliance issues,
            employment or contracting arrangements, website terms of use or
            privacy policies or practices.{" "}
          </p>
          <p>
            <b>
              Acknowledgement and Waiver of Potential Conflicts of Interest.{" "}
            </b>
            You understand that Foundry Law Group has represented and continues
            to represent many different businesses and individuals. In some
            cases our representation may have involved, or will involve, the
            firm or its attorneys in matters involving individuals associated
            with your business. So long as our representation is substantially
            unrelated to our LLC Builder work for your business, you agree that
            Foundry Law Group may represent existing or new clients in any
            matter, even if adverse to your business, and you waive any such
            conflict of interest that may arise in such circumstance. However,
            without your consent, in no event we will not represent another
            client in a matter adverse to your business if we have obtained
            confidential information of a nonpublic nature from you, as a result
            of our representation of your business, that, if known to the other
            client, could be used to your material disadvantage, unless we
            establish a “screen” to preserve the Company&apos;s confidences. You
            consent to this arrangement.
          </p>
          <p>
            <b>Conflict of Interest Check. </b>Upon your registration for the
            LLC Builder, prior to Foundry Law Group providing legal services, we
            are required to undertake a conflict of interest check in order to
            conform to the applicable rules of professional conduct for lawyers.
            If there is a conflict of interest, we may request a waiver or, if
            not waived or waivable for any reason, we will not be able to
            provide you with legal services and will refund any paid fees.{" "}
          </p>
          <p>
            <b>Authorization for Formation of your LLC. </b>By selecting the
            option to have us form your LLC with the State of Washington, you
            authorize Foundry Law Group to act as an authorized agent to
            complete, execute, and deliver a Certificate of Formation and
            Initial Report with the Secretary of the State of Washington.
          </p>
          <p>
            <b>LLC Builder Scope of Work.</b> The scope of services covered by
            the LLC Builder, the "LLC Builder Scope of Work," are those services
            and deliverables listed on the LLC Builder product description page
            under the summary of services. That summary of services and
            deliverable is incorporated into these terms of use.
          </p>
          <p>
            <b>Advance Payment of Flat Fees. </b> The LLC Builder is offered on
            a flat fee. Your payment of the legal fees will not be placed into a
            trust account and will be deemed property of Foundry Law Group when
            the payment is received. The fact that you have paid the fee in
            advance does not affect your right to terminate the client-lawyer
            relationship. In the event our relationship is terminated before the
            LLC Builder Scope of Work has been completed, you may or may not
            have a right to a refund of a portion of the fee.
          </p>
          <p>
            <b>Advance Payment of Expenses. </b>If you have chosen the option to
            have us file to form your LLC with the State of Washington, the
            advance payment of the filing fees charged by the State of
            Washington are deposited directly into our Foundry Law Group client
            trust account. These funds will be transferred to our business
            account following our payment of those filing fees on your behalf.
          </p>
          <p>
            <b>Use and Ownership Rights. </b>You are given rights to use the LLC
            Builder and all of the documents we provide solely in connection
            with your company and its business. The LLC Builder is a legal tool
            designed and operated by Foundry Law Group PLLC. We reserve all
            rights in the LLC Builder, including the form, structure, design,
            and all documents and the contents of all documents, instructions,
            or other material made available through the LLC Builder.
          </p>
          <p>
            <b>Restrictions on Use. </b>You may not use the LLC Builder for any
            purpose other than its stated purpose, which is the creation of an
            LLC and development of an operating agreement for a bona fide
            business purpose. You may not use the LLC Builder to (1) sell
            investments in your business to investors, (2) access any portion of
            the LLC Builder tool in order to assist in building a competing
            product or service, or (3) conduct any illegal activity (including
            operation of an unlawful business).
          </p>
          <p>
            <b>Dispute Resolution. </b> In the unlikely event that a dispute
            arises between us stemming from this engagement, we both agree to
            use our best efforts to resolve such disputes in good faith. If we
            are not able to reach a mutual agreement within three months of
            either party giving notice of the dispute, we both agree to submit
            the matter to binding arbitration by a single arbitrator in
            accordance with the rules of JAMS. The arbitration shall take place
            in King County, Washington. We will first attempt to agree on a
            mutually acceptable arbitrator, otherwise, we will each appoint an
            arbitrator who, working together, will appoint a third arbitrator to
            serve as the sole arbiter of the dispute. The prevailing party may
            enter any judgment and award rendered by the arbitrator in any court
            having appropriate jurisdiction. The prevailing party may also, at
            the reasonable discretion of the arbitrator, be entitled to
            compensation for attorney&apos;s fees and costs of arbitration if
            the arbitrator determines that the non-prevailing party has not
            acted in good faith.
          </p>
          <p>
            I hereby confirm that I have read, understood, and agree to the
            Terms of Use and Limited Engagement Agreement
            <span style={{ color: "red" }}>*</span>
          </p>
        </div>
        <form className="row mb-3 d-flex align-items-end form-main">
          <div className="col-lg-12 mb-3">
            <img
              src={`${signature}`}
              style={{ width: "100%", height: 80 }}
              alt="e-signature"
            />
          </div>
          <div className="row">
            <div className="col-lg-6 mb-3">
              <label htmlFor="signFirstName" className="form-label">
                First Name
              </label>
              <input
                type="text"
                className="form-control"
                id="signFirstName"
                aria-describedby="emailHelp"
                value={signFirstName}
              />
            </div>
            <div className="col-lg-6 mb-3">
              <label htmlFor="signLastName" className="form-label">
                Last Name
              </label>
              <input
                type="text"
                className="form-control"
                id="signLastName"
                value={signLastName}
              />
            </div>
            <div className="col-lg-6 mb-3">
              <label htmlFor="signFirstName" className="form-label">
                Signer's IP Address
              </label>
              <input
                type="text"
                className="form-control"
                id="signFirstName"
                aria-describedby="emailHelp"
                value={ip}
              />
            </div>
            <div className="col-lg-6 mb-3">
              <label htmlFor="signLastName" className="form-label">
                Signed On
              </label>
              <input
                type="text"
                className="form-control"
                id="signLastName"
                value={new Date().toLocaleString("en-US", {
                  month: "long",
                  day: "numeric",
                  year: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                  second: "numeric",
                })}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
export default MultiMemberLLCAgreement;
